import * as React from "react";
import { Button } from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";
import { saveAs } from "file-saver";
import FileApi from "../../../api/FileApi";
import { withStyles } from "@material-ui/core";

type ExportBidLogButtonProps = {
    parcelId: string;
    parcelName: string;
    auctionName: string;
};
const WhiteButton = withStyles({
    root: {
        root: {
            backgroundColor: "#000",
            color: "rgba(248, 179, 50, 1)"
        }
    }
})(Button);

class ExportBidLogCSVButton extends React.Component<
    ExportBidLogButtonProps,
    {}
> {
    public render() {
        return (
            <WhiteButton
                size="small"
                variant="outlined"
                color="primary"
                onClick={this.downloadFile}
            >
                <CloudDownload />
                &nbsp; Download
            </WhiteButton>
        );
    }

    private downloadFile = async () => {
        if (this.props.parcelId) {
            const result = await FileApi.GetParcelBidsLogCsvFile(
                this.props.parcelId,
                this.props.auctionName,
                this.props.parcelName
            );
            saveAs(result.blob, result.fileName);
        }
    };
}

export default ExportBidLogCSVButton;
